import { VCol } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Section',{attrs:{"light":_vm.light,"medium":_vm.medium,"gray":_vm.gray}},[_c(VCol,{staticClass:"col-sm-6"},[_vm._t("left")],2),_c(VCol,{staticClass:"col-sm-6"},[_vm._t("right")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }